module.exports = __webpack_public_path__ + "img/location.a65d9f7e.svg";